import type { CyanGoalPlan } from "./types";

import {
  resolveGoalCapabilities,
  type GoalCapabilityResolution,
} from "./capabilityResolution";

import {
  CyanWorkerSelectionService,
  type CapabilityAvailabilityReader,
} from "./workerSelectionService";

export class CyanGoalCapabilityService {
  private readonly selection: CyanWorkerSelectionService;

  constructor(availability: CapabilityAvailabilityReader) {
    this.selection = new CyanWorkerSelectionService(availability);
  }

  resolvePlan(plan: CyanGoalPlan): GoalCapabilityResolution {
    const requiredCapabilities = [
      ...new Set(plan.steps.flatMap((step) => step.capabilities)),
    ];

    const evidence = this.selection.resolve(requiredCapabilities);

    return resolveGoalCapabilities(plan, evidence);
  }
}
